import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Cell } from 'recharts'
import { axisStyle, bandAxisStyle } from './shared'
import { ChartData } from './type'

type Props = {
  data: ChartData[]
  /** Sets the y-axis ceiling; the axis itself stays hidden. */
  ticks: number[]
  height?: number
  barRadius?: number
  width?: number
  animated?: boolean
}

/** Columns and band labels only — the numbers live in the card's caption. */
export const BarChartComponent = ({ data, ticks, height = 300, barRadius = 4, width, animated = true }: Props) => {
  const yMax: number | string = ticks[ticks.length - 1] ?? 'dataMax'

  const chart = (
    <BarChart data={data} width={width} height={height} margin={{ top: 8, right: 0, bottom: 0, left: 0 }}>
      <XAxis dataKey="name" tickLine={false} axisLine={false} tick={bandAxisStyle} height={32} />
      <YAxis hide domain={[0, yMax]} ticks={ticks} axisLine={false} tickLine={false} tick={axisStyle} />

      <Bar
        dataKey="value"
        name="category"
        fill="#8884d8"
        radius={[barRadius, barRadius, 0, 0]}
        isAnimationActive={animated}
      >
        {data.map(({ color }, index) => (
          <Cell key={`cell-${index}`} fill={color} />
        ))}
      </Bar>
    </BarChart>
  )

  if (width) return chart

  return (
    <ResponsiveContainer width="100%" height={height}>
      {chart}
    </ResponsiveContainer>
  )
}
